import { render } from "./DangCardBase.vue?vue&type=template&id=e9740fbc&scoped=true"
import script from "./DangCardBase.vue?vue&type=script&lang=js"
export * from "./DangCardBase.vue?vue&type=script&lang=js"

import "./DangCardBase.vue?vue&type=style&index=0&id=e9740fbc&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9740fbc"]])

export default __exports__